export interface PostalCard {
  id: number;
  image: string;
  title: string;
  date: string;
  location: string;
}

export const postalCards: PostalCard[] = [

  // {
  //   id: 200,
  //   image: require("@/assets/postcards/2025-04-03-lemans-manger.png"),
  //   title: "Manger et ses synonymes",
  //   date: "2025-04-03",
  //   location: "Le Mans, France",
  // },
  // {
  //   id: 300,
  //   image: require("@/assets/postcards/2025-04-03-lemans-shrimp.png"),
  //   title: "Culture Humaine by Blossom",
  //   date: "2025-04-03",
  //   location: "Le Mans, France",
  // },
  {
    id: 1,
    image: require("@/assets/postcards/2025-01-05-vaureal-plan.png"),
    title: "Plan de Vauréal",
    date: "2025-01-05",
    location: "Vauréal, France",
  },
  {
    id: 2,
    image: require("@/assets/postcards/2025-01-11-cergy-fleurs.png"),
    title: "Les fleurs de la serpette",
    date: "2025-01-11",
    location: "Cergy, France",
  },
  {
    id: 3,
    image: require("@/assets/postcards/2025-01-11-houillescarriere-sncfpaint.png"),
    title: "Peinture SNCF",
    date: "2025-01-11",
    location: "Houilles Carrières-sur-Seine, France",
  },
  {
    id: 4,
    image: require("@/assets/postcards/2025-01-11-paris-kingbeer.png"),
    title: "Le Roi de la Bière",
    date: "2025-01-11",
    location: "Paris, France",
  },
  {
    id: 5,
    image: require("@/assets/postcards/2025-01-12-paris-comeprima.png"),
    title: "Come Prima",
    date: "2025-01-12",
    location: "Paris, France",
  },
  {
    id: 6,
    image: require("@/assets/postcards/2025-01-12-vaureal-enfant.png"),
    title: "Enfant Bariolé",
    date: "2025-01-12",
    location: "Vauréal, France",
  },
  {
    id: 7,
    image: require("@/assets/postcards/2025-01-14-neuville-pompiers.png"),
    title: "Tag Soldats du feu",
    date: "2025-01-14",
    location: "Neuville, France",
  },
  {
    id: 8,
    image: require("@/assets/postcards/2025-01-15-cergy-spidercolor.png"),
    title: "Spider color",
    date: "2025-01-15",
    location: "Cergy, France",
  },
  {
    id: 9,
    image: require("@/assets/postcards/2025-01-16-paris-colors.png"),
    title: "Couleurs",
    date: "2025-01-16",
    location: "Paris, France",
  },
  {
    id: 10,
    image: require("@/assets/postcards/2025-01-16-paris-geode.png"),
    title: "Géode",
    date: "2025-01-16",
    location: "Paris, France",
  },
  {
    id: 11,
    image: require("@/assets/postcards/2025-01-16-paris-lettres.png"),
    title: "Lettres de la Villette",
    date: "2025-01-16",
    location: "Paris, France",
  },
  {
    id: 12,
    image: require("@/assets/postcards/2025-01-16-paris-paon.png"),
    title: "Fier comme un paon",
    date: "2025-01-16",
    location: "Paris, France",
  },
  {
    id: 13,
    image: require("@/assets/postcards/2025-01-16-paris-selor.png"),
    title: "Street art - Selor",
    date: "2025-01-16",
    location: "Paris, France",
  },
  {
    id: 14,
    image: require("@/assets/postcards/2025-01-17-vaureal-jardin.png"),
    title: "Jardins partagés",
    date: "2025-01-17",
    location: "Vauréal, France",
  },
  {
    id: 15,
    image: require("@/assets/postcards/2025-01-18-paris-bluequeen.png"),
    title: "Medieval Queen in blue",
    date: "2025-01-18",
    location: "Paris, France",
  },
  {
    id: 16,
    image: require("@/assets/postcards/2025-01-18-paris-tintin.png"),
    title: "Tintin in love with Haddock",
    date: "2025-01-18",
    location: "Paris, France",
  },
  {
    id: 17,
    image: require("@/assets/postcards/2025-01-19-paris-fresque.png"),
    title: "Fresque des Dedjeeze",
    date: "2025-01-19",
    location: "Paris, France",
  },
  {
    id: 18,
    image: require("@/assets/postcards/2025-01-21-lille-romeojuliet.png"),
    title: "Coeur Juliet & Roméo",
    date: "2025-01-21",
    location: "Lille, France",
  },
  {
    id: 19,
    image: require("@/assets/postcards/2025-01-23-cergy-colonneshubert.png"),
    title: "Place des colonnes Hubert Renaud",
    date: "2025-01-23",
    location: "Cergy, France",
  },
  {
    id: 20,
    image: require("@/assets/postcards/2025-01-23-paris-alafolie.png"),
    title: "A la folie",
    date: "2025-01-23",
    location: "Paris, France",
  },
  {
    id: 21,
    image: require("@/assets/postcards/2025-01-23-paris-citedesenfants.png"),
    title: "Cité des Enfants",
    date: "2025-01-23",
    location: "Paris, France",
  },
  {
    id: 22,
    image: require("@/assets/postcards/2025-01-24-lille-graff.png"),
    title: "Graff Wazemmes",
    date: "2025-01-24",
    location: "Lille, France",
  },
  {
    id: 23,
    image: require("@/assets/postcards/2025-01-25-cergy-touspareil.png"),
    title: "On est tous pareils !",
    date: "2025-01-25",
    location: "Cergy, France",
  },
  {
    id: 24,
    image: require("@/assets/postcards/2025-01-25-paris-ecoute.png"),
    title: "Ecoute, by Henri de Miller",
    date: "2025-01-25",
    location: "Paris, France",
  },
  {
    id: 25,
    image: require("@/assets/postcards/2025-01-25-paris-stlazare.png"),
    title: "Horloges de Saint-Lazare",
    date: "2025-01-25",
    location: "Paris, France",
  },
  {
    id: 26,
    image: require("@/assets/postcards/2025-01-28-ladefense-association.png"),
    title: "Association du site de La Défense",
    date: "2025-01-28",
    location: "La Défense, France",
  },
  {
    id: 27,
    image: require("@/assets/postcards/2025-01-28-ladefense-poulpe.png"),
    title: "Ici ça poulpe !",
    date: "2025-01-28",
    location: "La Défense, France",
  },
  {
    id: 28,
    image: require("@/assets/postcards/2025-02-01-cergy-squelette.png"),
    title: "Squelette",
    date: "2025-02-01",
    location: "Cergy, France",
  },
  {
    id: 29,
    image: require("@/assets/postcards/2025-02-01-vaureal-venus.png"),
    title: "La Vénus du Soleil",
    date: "2025-02-01",
    location: "Vauréal, France",
  },
  {
    id: 30,
    image: require("@/assets/postcards/2025-02-03-paris-twogirls.png"),
    title: "Two girls, one door",
    date: "2025-02-03",
    location: "Paris, France",
  },
  {
    id: 31,
    image: require("@/assets/postcards/2025-02-07-paris-chaperonrouge.png"),
    title: "Chaperon Rouge et le Loup",
    date: "2025-02-07",
    location: "Paris, France",
  },
  {
    id: 32,
    image: require("@/assets/postcards/2025-02-07-paris-coupolecafe.png"),
    title: "Coupole du café",
    date: "2025-02-07",
    location: "Paris, France",
  },
  {
    id: 33,
    image: require("@/assets/postcards/2025-02-07-paris-petiteceinture.png"),
    title: "Maison Graffiti sur la Petite Ceinture",
    date: "2025-02-07",
    location: "Paris, France",
  },
  {
    id: 34,
    image: require("@/assets/postcards/2025-02-09-paris-pontcolore.png"),
    title: "Petit Pont Coloré",
    date: "2025-02-09",
    location: "Paris, France",
  },
  {
    id: 35,
    image: require("@/assets/postcards/2025-02-12-houilles-boulangere.png"),
    title: "La Boulangère",
    date: "2025-02-12",
    location: "Houilles Carrières-sur-Seine, France",
  },
  {
    id: 36,
    image: require("@/assets/postcards/2025-02-12-paris-bklnqueen.png"),
    title: "BKLN Queens",
    date: "2025-02-12",
    location: "Paris, France",
  },
  {
    id: 37,
    image: require("@/assets/postcards/2025-02-12-paris-cariatide.png"),
    title: "Tradition et Nature",
    date: "2025-02-12",
    location: "Paris, France",
  },
  {
    id: 38,
    image: require("@/assets/postcards/2025-02-12-paris-cascadeconciergerie.png"),
    title: "Cascade de la Conciergerie",
    date: "2025-02-12",
    location: "Paris, France",
  },
  {
    id: 39,
    image: require("@/assets/postcards/2025-02-12-paris-metrogoncourt.png"),
    title: "Metro Goncourt",
    date: "2025-02-12",
    location: "Paris, France",
  },
  {
    id: 40,
    image: require("@/assets/postcards/2025-02-13-paris-stationhonore.png"),
    title: "Station T3b - Honoré de Balzac",
    date: "2025-02-13",
    location: "Paris, France",
  },
  {
    id: 41,
    image: require("@/assets/postcards/2025-02-13-saintouen-patinoire.png"),
    title: "Patinoire de Saint Ouen",
    date: "2025-02-13",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 42,
    image: require("@/assets/postcards/2025-02-14-paris-maisonratp.png"),
    title: "Metro XXe siècle maison de la RATP",
    date: "2025-02-14",
    location: "Paris, France",
  },
  {
    id: 43,
    image: require("@/assets/postcards/2025-02-14-paris-nation.png"),
    title: "Statue de la Nation",
    date: "2025-02-14",
    location: "Paris, France",
  },
  {
    id: 44,
    image: require("@/assets/postcards/2025-02-14-paris-passerelle.png"),
    title: "Passerelle pour Piétons",
    date: "2025-02-14",
    location: "Paris, France",
  },
  {
    id: 45,
    image: require("@/assets/postcards/2025-02-17-paris-chataile.png"),
    title: "Le chat ailé",
    date: "2025-02-17",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 46,
    image: require("@/assets/postcards/2025-02-17-paris-lezard.png"),
    title: "Le Lézard de Saint Lazare",
    date: "2025-02-17",
    location: "Paris, France",
  },
  {
    id: 47,
    image: require("@/assets/postcards/2025-02-18-garenncolombes-lumieres.png"),
    title: "Jets de lumières",
    date: "2025-02-18",
    location: "Garenne Colombes, France",
  },
  {
    id: 48,
    image: require("@/assets/postcards/2025-02-19-paris-horlogehotelmarine.png"),
    title: "Horloge de l'hôtel de la Marine",
    date: "2025-02-19",
    location: "Paris, France",
  },
  {
    id: 49,
    image: require("@/assets/postcards/2025-02-19-saintouen-ampere.png"),
    title: "Centre de Proximité Ampère",
    date: "2025-02-19",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 50,
    image: require("@/assets/postcards/2025-02-19-saintouen-jardinpedagoampere.png"),
    title: "Jardin Pédagogique Ampère",
    date: "2025-02-19",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 51,
    image: require("@/assets/postcards/2025-02-20-saintouen-beauxarts.png"),
    title: "Ecole des Beaux Arts",
    date: "2025-02-20",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 52,
    image: require("@/assets/postcards/2025-02-23-saintouen-comics.png"),
    title: "Fresque Comics",
    date: "2025-02-23",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 53,
    image: require("@/assets/postcards/2025-02-25-saintouen-canard.png"),
    title: "Le Canard de Totoff",
    date: "2025-02-25",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 54,
    image: require("@/assets/postcards/2025-02-25-saintouen-feeviolette.png"),
    title: "La Fée Violette",
    date: "2025-02-25",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 55,
    image: require("@/assets/postcards/2025-02-25-saintouen-stationrer.png"),
    title: "Station RER Saint Ouen",
    date: "2025-02-25",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 56,
    image: require("@/assets/postcards/2025-03-02-conflans-boulangerie.png"),
    title: "Boulangerie de la gare",
    date: "2025-03-02",
    location: "Conflans, France",
  },
  {
    id: 57,
    image: require("@/assets/postcards/2025-03-03-paris-immeubletaches.png"),
    title: "Immeuble aux tâches",
    date: "2025-03-03",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 58,
    image: require("@/assets/postcards/2025-03-03-saintouen-graffitigirls.png"),
    title: "Graffiti à Saint-Ouen sur Seine",
    date: "2025-03-03",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 59,
    image: require("@/assets/postcards/2025-03-04-palaiseau-3compagnons.png"),
    title: "Les 3 compagnons",
    date: "2025-03-04",
    location: "Palaiseau, France",
  },
  {
    id: 60,
    image: require("@/assets/postcards/2025-03-05-paris-squareopera.png"),
    title: "Statue du Square de l'Opéra Louis-Jouvet",
    date: "2025-03-05",
    location: "Paris, France",
  },
  {
    id: 61,
    image: require("@/assets/postcards/2025-03-06-garennecolombes-gare.png"),
    title: "Gare de la Garenne Colombes",
    date: "2025-03-06",
    location: "Garenne Colombes, France",
  },
  {
    id: 62,
    image: require("@/assets/postcards/2025-03-06-garennecolombes-lotus.png"),
    title: "Fleur de Lotus",
    date: "2025-03-06",
    location: "Garenne Colombes, France",
  },
  {
    id: 63,
    image: require("@/assets/postcards/2025-03-06-garennecolombes-plan.png"),
    title: "Plan de La Garenne-Colombes",
    date: "2025-03-06",
    location: "Garenne Colombes, France",
  },
  {
    id: 64,
    image: require("@/assets/postcards/2025-03-08-courbevoie-lionfruits.png"),
    title: "Lion and Fruits",
    date: "2025-03-08",
    location: "Courbevoie, France",
  },
  {
    id: 65,
    image: require("@/assets/postcards/2025-03-08-paris-espacevangoth.png"),
    title: "Espace Van Gogh",
    date: "2025-03-08",
    location: "Paris, France",
  },
  {
    id: 66,
    image: require("@/assets/postcards/2025-03-08-paris-fresquefruits.png"),
    title: "Fresque les fruits du jardin",
    date: "2025-03-08",
    location: "Paris, France",
  },
  {
    id: 67,
    image: require("@/assets/postcards/2025-03-08-paris-viator.png"),
    title: "Immeuble Viator",
    date: "2025-03-08",
    location: "Paris, France",
  },
  {
    id: 68,
    image: require("@/assets/postcards/2025-03-08-saintouen-statue.png"),
    title: "Statue",
    date: "2025-03-08",
    location: "Saint-Ouen-sur-Seine, France",
  },
  {
    id: 69,
    image: require("@/assets/postcards/2025-03-10-paris-marchecouvert.png"),
    title: "Graph Marché Couvert",
    date: "2025-03-10",
    location: "Paris, France",
  },
  {
    id: 70,
    image: require("@/assets/postcards/2025-03-11-bourdsaintmaurice-chapelle.png"),
    title: "Chapelle du Varet",
    date: "2025-03-11",
    location: "Bourg-Saint-Maurice, France",
  },
  {
    id: 71,
    image: require("@/assets/postcards/2025-03-11-nanterre-gare.png"),
    title: "Gare de Nanterre Université",
    date: "2025-03-11",
    location: "Nanterre, France",
  },
  {
    id: 72,
    image: require("@/assets/postcards/2025-03-11-paris-pontneuf.png"),
    title: "Le Pont Neuf",
    date: "2025-03-11",
    location: "Paris, France",
  },
  {
    id: 73,
    image: require("@/assets/postcards/2025-03-11-paris-rituel.png"),
    title: "Rituel Foch Club Privé",
    date: "2025-03-11",
    location: "Paris, France",
  },
  {
    id: 74,
    image: require("@/assets/postcards/2025-03-13-paris-bibliausterlitz.png"),
    title: "Bibliothèque partagée d'Austerlitz",
    date: "2025-03-13",
    location: "Paris, France",
  },
  {
    id: 75,
    image: require("@/assets/postcards/2025-03-16-garennecolombes-jeux.png"),
    title: "Aire de jeux - Square Boisel",
    date: "2025-03-16",
    location: "Garenne Colombes, France",
  },
  {
    id: 76,
    image: require("@/assets/postcards/2025-03-17-paris-jumelagegaredelyon.png"),
    title: "Jumelage Gare de Lyon - Gare de Séoul",
    date: "2025-03-17",
    location: "Paris, France",
  },
  {
    id: 77,
    image: require("@/assets/postcards/2025-03-18-paris-escalierarcenciel.png"),
    title: "L'escalier arc-en-ciel",
    date: "2025-03-18",
    location: "Paris, France",
  },
  {
    id: 78,
    image: require("@/assets/postcards/2025-03-19-paris-museeartdeco.png"),
    title: "Musée des Arts Décoratifs",
    date: "2025-03-19",
    location: "Paris, France",
  },
  {
    id: 79,
    image: require("@/assets/postcards/2025-03-21-cergy-cityrock.png"),
    title: "City Rock",
    date: "2025-03-21",
    location: "Cergy, France",
  },
  {
    id: 80,
    image: require("@/assets/postcards/2025-03-21-cergy-plancentreville.png"),
    title: "Plan du centre-ville",
    date: "2025-03-21",
    location: "Cergy, France",
  },
  {
    id: 81,
    image: require("@/assets/postcards/2025-03-22-cergy-passerellerouge.png"),
    title: "Passerelle de l'Axe Majeur",
    date: "2025-03-22",
    location: "Cergy, France",
  },
  {
    id: 82,
    image: require("@/assets/postcards/2025-03-24-maisonslaffitte-2emebassin.png"),
    title: "Deuxième Bassin",
    date: "2025-03-24",
    location: "Maisons-Laffitte, France",
  },
  {
    id: 83,
    image: require("@/assets/postcards/2025-03-24-maisonslaffitte-chateau.png"),
    title: "Château de Maisons-Laffitte",
    date: "2025-03-24",
    location: "Maisons-Laffitte, France",
  },
  {
    id: 84,
    image: require("@/assets/postcards/2025-03-24-maisonslaffitte-marlenedietritch.png"),
    title: "Portrait de Marlène Dietrich",
    date: "2025-03-24",
    location: "Maisons-Laffitte, France",
  },
  {
    id: 85,
    image: require("@/assets/postcards/2025-03-26-paris-vitraux.png"),
    title: "Vitraux Brasserie Mollard",
    date: "2025-03-26",
    location: "Paris, France",
  },
  {
    id: 86,
    image: require("@/assets/postcards/2025-03-26-paris-pasperdus.png"),
    title: "Salle des pas perdus",
    date: "2025-03-26",
    location: "Paris, France",
  },
  {
    id: 87,
    image: require("@/assets/postcards/2025-03-28-cergy-theworld.png"),
    title: "The World - Jojo's Bizarre Adventure",
    date: "2025-03-28",
    location: "Cergy, France",
  },
  {
    id: 88,
    image: require("@/assets/postcards/2025-03-28-cergy-bonjour.png"),
    title: "Bonjour du Bontemps",
    date: "2025-03-28",
    location: "Cergy, France",
  },
  {
    id: 89,
    image: require("@/assets/postcards/2025-03-30-cergy-clapmural.png"),
    title: "Peinture murale - Clap",
    date: "2025-03-30",
    location: "Paris, France",
  },
  {
    id: 90,
    image: require("@/assets/postcards/2025-03-31-courdimanche-tagmirapolis.png"),
    title: "Tag Mirapolis",
    date: "2025-03-31",
    location: "Courdimanche, France",
  },
  {
    id: 91,
    image: require("@/assets/postcards/2025-04-01-courdimanche-mirapolis.png"),
    title: "Parc d'attractions Mirapolis abandonné",
    date: "2025-04-01",
    location: "Courdimanche, France",
  },
  {
    id: 92,
    image: require("@/assets/postcards/2025-04-02-paris-girouette.png"),
    title: "Girouette du Diable",
    date: "2025-04-02",
    location: "Paris, France",
  },
  {
    id: 93,
    image: require("@/assets/postcards/2025-04-02-paris-jungle.png"),
    title: "La jungle",
    date: "2025-04-02",
    location: "Paris, France",
  },
  {
    id: 94,
    image: require("@/assets/postcards/2025-04-02-lemans-horloge.png"),
    title: "Peinture Murale - Horloge Romaine",
    date: "2025-04-02",
    location: "Le Mans, France",
  },
];
